import { Box } from "@nulogy/components";
import styled from "styled-components";

const JobCount = styled(Box)(({ theme }) => ({
  display: "inline-block",
  fontWeight: theme.fontWeights.medium,
}));

export default JobCount;
